export default __webpack_public_path__ + "static/screeny-85-gpz-s-1-342f27d501006c8b1160d0ace0c16e61.jpg";